export enum ACTIONS {
	INIT_POSITIONS = 'initPositions',
	ADJUST_INIT_POSITIONS = 'adjustInitPositions',
	UPDATE_STREAM_POSITIONS = 'updateStream',
	UPDATE_LOADING_POSITIONS = 'updateLoadingPos',
	END_STREAM = 'endStream',
}
